module.exports = __webpack_public_path__ + "static/media/flask.d98463ab.svg";